import { Component, Input, ViewChild } from "@angular/core";
import { FormControl, ReactiveFormsModule } from "@angular/forms";
import { NgClass, NgIf } from "@angular/common";
import {
  MatDatepickerModule,
  MatDateRangeInput,
  MatDateRangePicker,
  MatEndDate,
  MatStartDate,
} from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { InputLabelComponent } from "../input-label/input-label.component";
import { SafeHTMLPipe } from "src/pipes/safe-html.pipe";
import { calendarBlackSVG } from "src/constants/svg/calendar-black";
import { SharedAppModule } from "src/pages/shared/shared.module";

@Component({
  selector: "app-date-range-input",
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    SharedAppModule,
    MatDatepickerModule,
    NgClass,
    NgIf,
    InputLabelComponent,
  ],
  templateUrl: "./date-range-input.component.html",
  styleUrls: ["./date-range-input.component.scss"],
})
export class DateRangeInputComponent {
  isFocussed = false;
  // For checking picker opened the first time or not.
  isPickedOpened = false;
  @Input() maxDate: Date = new Date(); // Sets maxDate to today's date

  readonly calendarBlackSVG = calendarBlackSVG;
  @Input() label?: string;
  @Input() isRequired?: boolean;
  @Input() startDateControl!: FormControl;
  @Input() endDateControl!: FormControl;
  @ViewChild("rangePicker") private rangePicker!: MatDateRangePicker<any>;

  openRangePicker() {
    this.isFocussed = true;
    this.rangePicker.open();
  }

  closeRangePicker() {
    this.isFocussed = false;
    this.isPickedOpened = true;
  }

  resetInput() {
    this.startDateControl.reset();
    this.endDateControl.reset();
  }
}
